import React, { useState, useEffect } from 'react';
import AdminLayoutWrapper from '../../components/layout/AdminLayoutWrapper';
import QuestionAnalytics from '../../components/analytics/QuestionAnalytics';
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert
} from '@mui/material';
import api from '../../services/api';
import { ACADEMIC_YEAR_BOARD_SUBJECT_TOPICS, QUESTIONS, SUBJECT_TOPICS } from '../../config/Config';

const fetchPaginatedList = async (url) => {
  let nextUrl = url;
  let all = [];
  while (nextUrl) {
    const response = await api.get(nextUrl);
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    all = all.concat(data.results || []);
    nextUrl = data.next || null;
  }
  return all;
};

const AdminQuestionAnalyticsPage = () => {
  const [questions, setQuestions] = useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [curriculumAssociations, setCurriculumAssociations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch all questions (admin can see all questions)
        const questionsList = await fetchPaginatedList(`${QUESTIONS}?page_size=10000`);
        
        // Fetch all topics
        const topicsList = await fetchPaginatedList(`${SUBJECT_TOPICS}?page_size=10000`);

        const associationsList = await fetchPaginatedList(`${ACADEMIC_YEAR_BOARD_SUBJECT_TOPICS}?page_size=10000&is_active=true`);
        
        setQuestions(questionsList);
        setAllTopics(topicsList);
        setCurriculumAssociations(associationsList);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to fetch questions and topics data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <AdminLayoutWrapper>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      </AdminLayoutWrapper>
    );
  }

  if (error) {
    return (
      <AdminLayoutWrapper>
        <Box sx={{ p: 3 }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </AdminLayoutWrapper>
    );
  }

  return (
    <AdminLayoutWrapper>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
          Question Analytics - System Overview
        </Typography>
        
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Total Questions: {questions.length}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page shows analytics for all questions across the entire system.
          </Typography>
        </Paper>

        <QuestionAnalytics 
          questions={questions}
          allTopics={allTopics}
          curriculumAssociations={curriculumAssociations}
          role="admin"
          selfOnly={false}
          userId={null}
        />
      </Box>
    </AdminLayoutWrapper>
  );
};

export default AdminQuestionAnalyticsPage;
